export const LOGIN_USER = "LOGIN_USER";
export const SAVE_USER_PROFILE = "SAVE_USER_PROFILE";
export const LOGOUT_USER = "LOGOUT_USER";
export const USER_LOADED = "constUSER_LOADED";
export const USER_LOADING = "constUSER_LOADING";
export const USER_UPDATE = "USER_UPDATE";
export const AUTH_ERROR = "constAUTH_ERROR";
export const LOGIN_SUCCESS = "constLOGIN_SUCCESS";
export const LOGIN_FAIL = "constLOGIN_FAIL";
export const LOGOUT_SUCCESS = "constLOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "constREGISTER_SUCCESS";
export const REGISTER_FAIL = "constREGISTER_FAIL";
export const GET_ERROR = "GET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const LEFT_SWITCH = "LEFT_SWITCH";
export const RIGHT_SWITCH = "RIGHT_SWITCH";
export const FILE_UPLOADING = "FILE_UPLADING";
export const FILE_UPLOADED = "FILE_UPLOADED";
export const FILE_SELECTING = "FILE_SELECTING";
export const IMAGE_SELECTING = "FILE_SELECTING";
export const INPUTS_SAVED = "INPUTS_SAVED";
export const INPUTS_SAVING = "INPUTS_SAVING";
export const INPUTS_SAVING_FAILED = "NPUTS_SAVING_FAILED";
export const ROUTES_RULES_LOADING = "ROUTES_RULES_LOADING";
export const ROUTES_RULES_LOADED = "ROUTES_RULES_LOADED";
export const ROUTES_RULES_FAILED = "ROUTES_RULES_FAILED";
export const ROUTES_SAVED = "ROUTES_SAVED";
export const ROUTES_SAVING = "ROUTES_SAVING";
export const ROUTES_SAVING_FAILED = "ROUTES_SAVING_FAILED";
export const ROUTES_FAILED = "ROUTES_FAILED";
export const GET_DOCS_SUCCESSED = "GET_DOCS_SUCCESSED";
export const GET_DOCS_FAILED = "GET_DOCS_SUCCESSED";
export const GET_ONE_DOCS_FAILED = "GET_ONE_DOCS_FAILED";
export const GET_ONE_DOCS_SUCCESSED = "GET_ONE_DOCS_SUCCESSED";
export const GET_OFFICE_DOCS_FAILED = "GET_ONE_DOCS_FAILED";
export const GET_OFFICE_DOCS_SUCCESSED = "GET_ONE_DOCS_SUCCESSED";
export const DOC_SUBMITED = "DOC_SUBMITED";
export const DOC_SUBMITTING = "DOC_SUBMITTING";
export const DOC_SUBMITTING_FAILED = "DOC_SUBMITTING_FAILED";
export const DOC_SUBMITTING_INITIALIZE = "DOC_SUBMITTING_INITALIZE";
export const CLEAR_FILEUPLOAD = "CLEAR_FILEUPLOAD";
export const CLEAR_INPUTSAVE = "CLEAR_INPUTSAVE";
export const CLEAR_LOADROUTES = "CLEAR_LOADROUTES";
export const FILE_UNSELECTING = "FILE_UNSELECTING";
export const IMAGE_UNSELECTING = "FILE_UNSELECTING";
export const DOC_SAVING_FAILED = "DOC_SAVING_FAILED";
export const DOC_SAVING_SUCCESSED = "DOC_SAVING_SUCCESSED";
export const FILE_UNSELECTING_ALL = "FILE_UNSELECTING_ALL";
export const DOC_APPROVED = "DOC_APPROVED";
export const DOC_APPROVING = "DOC_APPROVING";
export const DOC_APPROVING_FAILED = "DOC_APPROVING_FAILED";
export const DOC_APPROVING_INITIALIZE = "DOC_APPROVING_INITIALIZE";
export const DOC_COMMENTED = "DOC_COMMENTED";
export const DOC_COMMENTING = "DOC_COMMENTING";
export const DOC_COMMENTING_FAILED = "DOC_COMMENTING_FAILED";
export const DOC_COMMENTING_INITIALIZE = "DOC_COMMENTING_INITIALIZE";
export const GET_DOCS_REQ_FAILED = "GET_ONE_DOCS_FAILED";
export const GET_DOCS_REQ_SUCCESSED = "GET_ONE_DOCS_SUCCESSED";
export const GET_DOCS_REQ_INITIALIZE = "GET_DOCS_REQ_INITIALIZE";
export const CLEAR_IMAGEUPLOAD = "CLEAR_IMAGEUPLOAD";
export const IMAGE_UPLOADING = "IMAGE_UPLADING";
export const IMAGE_UPLOADED = "IMAGE_UPLOADED";
export const USER_STATUS_FAILED = "USER_STATUS_FAILED";
export const USER_STATUS_SAVING = "USER_STATUS_SAVING";
export const USER_STATUS_SAVED = "USER_STATUS_SAVED";
export const USER_STATUS_INITIALIZE = "USER_STATUS_INITIALIZE";
export const GET_DOCS_REQ_LOADING = "GET_DOCS_REQ_LOADING";
export const DOC_INIT = "DOC_INIT";
export const DOC_SIGNED = "DOC_SIGNED";
export const DOC_SIGNING = "DOC_SIGNING";
export const DOC_SIGNING_FAILED = "DOC_SIGNING_FAILED";
export const DOC_SIGNING_INITIALIZE = "DOC_SIGNING_INITIALIZE";
export const NOTIFICATION_INIT = "NOTIFICATION_INIT";
export const NOTIFICATION_LOADED = "NOTIFICATION_LOADED";
export const NOTIFICATION_LOADING = "NOTIFICATION_LOADING";
export const NOTIFICATION_LOADING_FAILED = "NOTIFICATION_LOADING_FAILED";
export const DATA_LOADING = "DATA_LOADING";
export const DATA_SAVING_FAILED = "DATA_SAVING_FAILED";
export const DATA_SAVING_SUCCESSED = "DATA_SAVING_SUCCESSED";
export const TRAVEL_LOADING = "TRAVEL_LOADING";
export const TRAVEL_SAVING_FAILED = "TRAVEL_SAVING_FAILED";
export const TRAVEL_SAVING_SUCCESSED = "TRAVEL_SAVING_SUCCESSED";
export const TRAVEL_LINK_LOADING = "TRAVEL_LINK_LOADING";
export const TRAVEL_LINK_SAVING_FAILED = "TRAVEL_LINK_SAVING_FAILED";
export const TRAVEL_LINK_SAVING_SUCCESSED = "TRAVEL_LINK_SAVING_SUCCESSED";
export const SHOP_CATEGOTY_INIT = "SHOP_CATEGOTY_INIT";
export const SHOP_CATEGOTY_SAVED = "SHOP_CATEGOTY_SAVED";
export const SHOP_CATEGOTY_SAVING = "SHOP_CATEGOTY_SAVING";
export const SHOP_CATEGOTY_SAVING_FAILED = "SHOP_CATEGOTY_SAVING_FAILED";
export const SHOP_PRODUCT_SAVED = "SHOP_PRODUCT_SAVED";
export const SHOP_PRODUCT_SAVING = "SHOP_PRODUCT_SAVING";
export const SHOP_PRODUCT_SAVING_FAILED = "SHOP_PRODUCT_SAVING_FAILED";
export const CLEAR_SHOPINPUTSAVE = "CLEAR_SHOPINPUTSAVE";
export const SHOPDATA_INIT = "SHOPDATA_INIT";
export const SHOPDATA_LOADING = "SHOPDATA_LOADING";
export const SHOPDATA_SAVING_FAILED = "SHOPDATA_SAVING_FAILED";
export const SHOPDATA_SAVING_SUCCESSED = "SHOPDATA_SAVING_SUCCESSED";
export const MASTERDATA_LOADING = "MASTERDATA_LOADING";
export const MASTERDATA_SAVING_FAILED = "MASTERDATA_SAVING_FAILED";
export const MASTERDATA_SAVING_SUCCESSED = "MASTERDATA_SAVING_SUCCESSED";
export const SHOPIMAGE_SAVING_FAILED = "SHOPIMAGE_SAVING_FAILED";
export const SHOPIMAGE_SAVING_SUCCESSED = "SHOPIMAGE_SAVING_SUCCESSED";
export const SHOPALBUM_LOADING = "SHOPALBUM_LOADING";
export const SHOPALBUM_SAVING_FAILED = "SHOPALBUM_SAVING_FAILED";
export const SHOPALBUM_SAVING_SUCCESSED = "SHOPALBUM_SAVING_SUCCESSED";
export const CLEAR_SHOPIMAGESSAVE = "CLEAR_SHOPIMAGESSAVE";
export const SHOP_IMAGE_SAVED = "SHOP_IMAGE_SAVED";
export const SHOP_IMAGE_SAVING = "SHOP_IMAGE_SAVING";
export const SHOP_IMAGE_SAVING_FAILED = "SHOP_IMAGE_SAVING_FAILED";
export const COMPANY_SAVED = "COMPANY_SAVED";
export const COMPANY_SAVING = "COMPANY_SAVING";
export const COMPANY_SAVING_FAILED = "COMPANY_SAVING_FAILED";
export const COMPANY_SAVING_INITIALIZE = "COMPANY_SAVING_INITIALIZE";
export const COMPANY_LOAD_INFO = "COMPANY_LOAD_INFO";
export const COMPANY_LOAD_INIT = "COMPANY_LOAD_INIT";
export const OFFICE_SAVED = "OFFICE_SAVED";
export const OFFICE_SAVING = "OFFICE_SAVING";
export const OFFICE_SAVING_FAILED = "OFFICE_SAVING_FAILED";
export const OFFICE_SAVING_INITIALIZE = "OFFICE_SAVING_INITIALIZE";
export const OFFICE_LOAD_INFO = "OFFICE_LOAD_INFO";
export const OFFICE_LOAD_INFO_INIT = "OFFICE_LOAD_INFO_INIT";
export const COMPANY_SELECTING = "COMPANY_SELECTING";
export const COMPANY_INIT = "COMPANY_INIT";
export const COMPANY_SELECTED = "COMPANY_SELECTED";
export const APP_REGISTER_LOADING = "APP_REGISTER_LOADING";
export const APP_SAVE_USER_INFO = "APP_SAVE_USER_INFO";
export const APP_SAVE_USER_TOKEN = "APP_SAVE_USER_TOKEN";
export const APP_SAVE_USER_TOKEN_FAILED = "APP_SAVE_USER_TOKEN_FAILED";
export const APP_SAVE_DEVICE_INFO = "APP_SAVE_DEVICE_INFO";
export const APP_REGISTER_COMPLETED = "APP_REGISTER_COMPLETED";
export const APP_REGISTER_FAILED = "APP_REGISTER_FAILED";
export const APP_REGISTER_INIT = "APP_REGISTER_INIT";
export const APP_SAVE_USER_INFO_FAIL = "APP_SAVE_USER_INFO_FAIL";
export const DASHBOARD_ORDER_INIT = "DASHBOARD_ORDER_INIT";
export const DASHBOARD_ORDER_LOADED = "DASHBOARD_ORDER_LOADED";
export const DASHBOARD_ORDER_LOADING = "DASHBOARD_ORDER_LOADING";
export const DASHBOARD_ORDER_ERROR = "DASHBOARD_ORDER_ERROR";
export const DASHBOARD_SALES_ERROR = "DASHBOARD_SALES_ERROR";
export const DASHBOARD_SALES_INIT = "DASHBOARD_SALES_INIT";
export const DASHBOARD_SALES_LOADED = "DASHBOARD_SALES_LOADED";
export const DASHBOARD_SALES_LOADING = "DASHBOARD_SALES_LOADING";
export const DASHBOARD_PROFIT_ERROR = "DASHBOARD_PROFIT_ERROR";
export const DASHBOARD_PROFIT_LOADED = "DASHBOARD_PROFIT_LOADED";
export const DASHBOARD_PROFIT_LOADING = "DASHBOARD_PROFIT_LOADING";
export const DASHBOARD_PROFIT_INIT = "DASHBOARD_PROFIT_INIT";
export const DASHBOARD_STOCKS_ERROR = "DASHBOARD_STOCKS_ERROR";
export const DASHBOARD_STOCKS_INIT = "DASHBOARD_STOCKS_INIT";
export const DASHBOARD_STOCKS_LOADED = "DASHBOARD_STOCKS_LOADED";
export const DASHBOARD_STOCKS_LOADING = "DASHBOARD_STOCKS_LOADING";
export const TAXES_LOADING = "TAXES_LOADING";
export const TAXES_SAVING = "TAXES_SAVING";
export const TAXES_LOADED = "TAXES_LOADED";
export const TAXES_SAVED = "TAXES_SAVED";
export const TAXES_FAILED = "TAXES_FAILED";
export const CURRENCIES_LOADING = "CURRENCIES_LOADING";
export const CURRENCIES_SAVING = "CURRENCIES_SAVING";
export const CURRENCIES_LOADED = "CURRENCIES_LOADED";
export const CURRENCIES_SAVED = "CURRENCIES_SAVED";
export const CURRENCIES_FAILED = "CURRENCIES_FAILED";
export const CURRENCY_SELECTED = "CURRENCY_SELECTED";
export const BARGAIN_LOADING = "BARGAIN_LOADING";
export const BARGAIN_SAVING = "BARGAIN_SAVING";
export const BARGAIN_LOADED = "BARGAIN_LOADED";
export const BARGAIN_SAVED = "BARGAIN_SAVED";
export const BARGAIN_FAILED = "BARGAIN_FAILED";
export const BARGAIN_PRICE_LOADED = "BARGAIN_PRICE_LOADED";